import { useState } from "react";
import { classSteps, tips } from "@/mocks/gossipData";

export default function ClassSection() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="class" className="scroll-mt-20 bg-paper-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6">
        <div className="flex flex-col gap-2">
          <p className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-sun-600">
            Microscope Class
          </p>
          <h2 className="font-heading text-2xl font-black text-ink-950 md:text-3xl">
            显微镜课堂 · 五步还原一次吃瓜
          </h2>
          <p className="mt-1 max-w-2xl text-sm leading-7 text-ink-500">
            把一套完整的方法拆成可以照做的五步。点开任意一步，看它在这一步到底要做什么、要注意什么。
          </p>
        </div>

        <div className="mt-8 grid gap-8 lg:grid-cols-[1.15fr_0.85fr]">
          <div className="relative">
            <span className="absolute bottom-6 left-[19px] top-6 w-px bg-ink-800/15" />
            <div className="flex flex-col gap-4">
              {classSteps.map((s, i) => {
                const active = openIdx === i;
                return (
                  <div key={s.no} className="relative pl-14">
                    <button
                      type="button"
                      onClick={() => setOpenIdx(active ? -1 : i)}
                      aria-expanded={active}
                      className={`absolute left-0 top-4 flex h-10 w-10 items-center justify-center rounded-full border-2 font-display text-sm font-bold transition-colors ${
                        active
                          ? "border-sign-500 bg-sign-500 text-paper-50"
                          : "border-ink-800/20 bg-paper-50 text-ink-600 hover:border-sign-400"
                      }`}
                    >
                      {s.no}
                    </button>
                    <div
                      className={`rounded-xl border bg-paper-50 p-5 transition-colors ${
                        active ? "border-sign-300" : "border-ink-800/10"
                      }`}
                    >
                      <div className="flex items-center justify-between gap-3">
                        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-ink-900">
                          <i className={`text-lg ${s.icon} text-sign-600`} />
                          {s.title}
                        </h3>
                        <i
                          className={`transition-transform ${
                            active ? "rotate-180 text-sign-600" : "text-ink-400"
                          } ${active ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}`}
                        />
                      </div>
                      {active && (
                        <p className="mt-3 text-sm leading-7 text-ink-600 animate-rise">{s.desc}</p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <aside className="lg:sticky lg:top-24 lg:self-start">
            <div className="overflow-hidden rounded-xl border border-ink-800/10">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20editorial%20still%20life%20of%20an%20open%20notebook%20with%20handwritten%20checklist%2C%20magnifying%20glass%20and%20paper%20clips%20on%20cream%20desk%2C%20melon%20green%20and%20cinnabar%20red%20accent%20tones%2C%20soft%20natural%20light%2C%20documentary%20photography&width=760&height=480&seq=gua-class-side&orientation=landscape"
                alt="显微镜课堂笔记本与清单"
                className="h-44 w-full object-cover object-top md:h-52"
              />
            </div>
            <div className="mt-5 rounded-xl border border-ink-800/10 bg-paper-50 p-5">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-sign-100 text-sign-600">
                  <i className="ri-error-warning-line" />
                </span>
                <h3 className="font-heading text-base font-bold text-ink-900">五条吃瓜红线</h3>
              </div>
              <ul className="mt-4 flex flex-col gap-3">
                {tips.map((t, i) => (
                  <li key={t} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-melon-500 text-paper-50">
                      <i className="text-xs ri-check-line" />
                    </span>
                    <span className="text-sm leading-6 text-ink-600">
                      <span className="mr-1 font-display text-sign-600">{i + 1}</span>
                      {t}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}